// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import moment from 'moment';
import axios from 'axios';
import VueI18n from 'vue-i18n';
import AsyncComputed from 'vue-async-computed';
import InstantSearch from 'vue-instantsearch';
import enLocale from '@/resources/i18n/en.json';
import VueAnalytics from 'vue-analytics';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './stylus/main.styl';
import App from './App';
import router from './router';
import store from './store';

/*eslint-disable */
import * as types from '@/store/mutationTypes';
import { mapState, mapGetters } from 'vuex';
/* eslint-enable */

// Base Vue config
Vue.config.productionTip = false;
// Vue.config.devtools = true;  // True in dev, False in prod by default
Vue.config.performance = true;
Vue.http = Vue.prototype.$http = axios;
Vue.config.debug = (process.env.NODE_ENV !== 'production')
    && (process.env.NODE_ENV !== 'testing');

/* If we need to supress Vue warnings for dynamic content changes
Vue.config.warnHandler = function customWarnHandler(err, vm, info) {
    // handle error
    // `info` is a Vue-specific error info, e.g. which lifecycle hook
    // the error was found in. Only available in 2.2.0+
    console.log('Custom vue warn handler: ', err, vm.name, info);
};
*/

// Internationalization
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'en',
    messages: {
        en: enLocale
    }
});
/* eslint-disable */
Vue.filter('dateformat', function( dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dataStr).format(pattern)
});

Vue.mixin({
    methods : {
        // Required to remap colors from netengine icons
        remapColors(icons) {
            if(icons.includes('data:image/svg+xml')){
                let res;
                let p;
                p = `${this.$vuetify.theme.primary.replace("#","%23")}`;
                res = icons.replace(/\%232DAAE1/gi,p);
                res = res.replace(/\%232FA9E3/gi,p);
                res = res.replace(/\%2332ADEF/gi,p);
                res = res.replace(/\%234DCAED/gi,p);

                p = `${this.$vuetify.theme.secondary.replace("#","%23")}`;
                res = res.replace(/\%23C85737/gi,p);
                res = res.replace(/\%23EE7656/gi,p);
                res = res.replace(/\%23F14B1C/gi,p);
                res = res.replace(/\%23FC7853/gi,p);
                res = res.replace(/\%23FF6600/gi,p);
                res = res.replace(/\%23F60/gi,p);

                return res;
            }
            return icons;
        },
    }
});

Vue.use(AsyncComputed);

// Algolia instant search
Vue.use(InstantSearch);

// Vuetify setup with internationalisation
// Official Complispace colours
// Grey - #565959
// Cyan - #00ADEF
// Light Grey - #9EA5A3
// Purple - #663399
// Green - #70D22B
// Orange - #FF7F32


Vue.use(Vuetify, {
    theme: {
        primary: '#00ADEF',
        secondary: '#FF7F32',
        accent: '#565959',
        error: '#EF4C00',
        warning: '#AAAAAA',
        info: '#EFF3F6',
        success: '#70D22B'
    },
    // theme: {
    //     primary: '#663399',
    //     secondary: '#00D2FF',
    //     accent: '#663399',
    //     error: '#565959',
    //     warning: '#9EA5A3',
    //     info: '#70d22b',
    //     success: '#aa0000'
    // },
    lang: {
        t: (key, ...params) => i18n.t(key, params)
    },
    options: {
        customProperties: true
    }
});

const isProd = process.env.NODE_ENV === 'production';

if (process.env.NODE_ENV !== 'development') {
    Vue.use(VueAnalytics, {
        id: process.env.GOOGLE_ANALYTICS_ID,
        router,
        debug: {
            enabled: !isProd,
            sendHitTask: isProd
        },
        autoTracking: {
            // Auto track with custom data
            // pageviewTemplate(route) {
            //     return {
            //         page: route.path,
            //         title: document.title,
            //         location: window.location.href
            //     };
            // },
            screenview: true,
            pageviewOnLoad: false,
            exception: true,
            // page: false,
            // ignoreRoutes: ['home', '/contacts'],
        }
    });
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
    computed: {
        ...mapState({
            refreshToken: state => state.session.refreshToken,
            idpUri: state => state.session.idpUri,
            cursor: state => state.appearance.cursor,
            isFullScreen: state => state.appearance.isFullScreen
        }),

        ...mapGetters({
            isAuthenticated: 'session/isAuthenticated',
            authorizationUri: 'session/authorizationUri'
        })
    },
    mounted: function() {
      this.$el.addEventListener('click', this.onClickVue)
    },
    beforeDestroy: function () {
      this.$el.removeEventListener('click', this.onClickVue)
    },
    methods: {
      popupLogin() {
        if(this.refreshToken){
          this.$store.commit(types.SESSION_SET_REFRESH_TOKEN, false);

          const refreshUri = `${window.location.origin}/static/refresh.html`;
          const queryParams = `client_id=quicklinks&redirect_uri=${encodeURIComponent(refreshUri)}&scope=blah&response_type=token&state=`;
          const url = `https://${this.idpUri}/oauth2/authorize?${queryParams}`;

          const height = 500;
          const width = 400;
          const ow = window.open(url,
              //          const ow = window.open("http://testschool.localhost:9083/static/test.html#launch",
              'Refresh Session',
              `height=${height},width=${width},left=${(screen.width - width) / 2},top=${(screen.height - height) / 2},resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes`);

          const that = this;

          window.addEventListener('message', function elcb(event){
              // Do we trust the sender of this message?
              if (event.source !== ow ) return;
              if (event.origin !== window.location.origin &&
              !event.data.includes('access_token')) return;

              that.$store.dispatch('session/refresh', {
                  uri: event.data,
              });
              // FYI, hotjar and other things send 'message' so
              // must be sure we get the right one before removing
              window.removeEventListener('message', elcb);
              ow.close();
          });
        }
      },
      onClickVue: function (e) {
        this.popupLogin();
      }
    },
    i18n
});



// WEBPACK FOOTER //
// ./src/main.js